// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wb_a bhs_b"};